<template>
  <section class="CLSection">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="CL">
      <tip :info="info" />

      <div class="CLBody">
        <LateralMenu />

        <div class="CLContent">
          <div class="representativeHeader">
            <span class="representativeTitle">TROCAR REPRESENTANTES</span>
          </div>
          <br />

          <div class="stepContent">
            <b-steps v-model="activeStep">
              <b-step-item step="1">
                <h1 class="title">Dicas</h1>

                <span
                  >Hora de trocar os representantes da sua OE? Essa é uma etapa
                  muito importante para manter as informações da OE atualizadas,
                  então para que tudo seja feito da forma correta, se liga nas
                  dicas:
                </span>
                <br />
                <br />

                <span>1. {{ tip1 }}</span> <br />
                <span>2. {{ tip2 }}</span> <br />
                <span>3. {{ tip3 }}</span> <br />
                <br />

                <span>
                  Caso tenha alguma dúvida, dificuldade ou sugestão, entre em
                  contato conosco através do e-mail
                  <b>suporte@empower.vision</b>, será um imenso prazer te
                  ajudar. Então, vamos lá?
                </span>
                <br />
                <br />

                <b-button
                  @click.prevent="nextStep(1)"
                  style="display: block; margin: auto;"
                  class="button is-primary is-rounded"
                >
                  <b>Avançar</b>
                </b-button>
              </b-step-item>

              <b-step-item step="2">
                <h1 class="title">Selecionar</h1>

                <span>
                  Primeiramente, clique no representante que será trocado:
                </span>
                <br />
                <br />

                <div class="leaders">
                  <div @click="selectLeader('leader1')">
                    <SelectLeader
                      :leader="organization.leader1"
                      :class="leader1Selected ? 'leaderSelected' : ''"
                    />
                  </div>

                  <div @click="selectLeader('leader2')">
                    <SelectLeader
                      :leader="organization.leader2"
                      :class="leader2Selected ? 'leaderSelected' : ''"
                    />
                  </div>
                </div>
              </b-step-item>

              <b-step-item step="3">
                <h1 class="title">Novo Representante</h1>

                <div v-if="!recoveredUser && !notFound">
                  <span v-if="leaderSelected">
                    Insira o e-mail do(a) novo(a) representante que irá
                    substituir {{ leaderSelected.name }}:
                  </span>
                  <br />

                  <span style="color: red;">
                    ATENÇÃO: O e-mail deve ser o que o(a) usuário(a) utilizou
                    para se cadastrar na plataforma!
                  </span>

                  <b-field
                    label="E-mail"
                    label-position="on-border"
                    style="margin-top: 1rem;"
                  >
                    <b-input
                      v-model="newLeaderEmail"
                      placeholder="Ex.: nome@email.com"
                    ></b-input>
                  </b-field>

                  <b-button
                    class="button is-primary is-rounded"
                    @click="checkStudentEmail"
                    :disabled="!newLeaderEmail"
                  >
                    <span>Confirmar</span>
                  </b-button>
                </div>

                <div v-if="recoveredUser">
                  <b-message
                    type="is-success"
                    :title="
                      'Esse(a) foi o(a) estudante encontrado(a) através do e-mail ' +
                        newLeaderEmail
                    "
                    :closable="false"
                  >
                    <b>Nome:</b> {{ recoveredUser.name }}
                    {{ recoveredUser.surname }} <br />
                    <b>Curso:</b> {{ recoveredUser.course }} <br />
                    Essas informações correspondem aos dados do(a) novo(a)
                    representante? <br />
                    <br />

                    <b-button
                      type="is-danger"
                      @click="tryAgain"
                      style="margin: 1rem;"
                    >
                      Não. Vou tentar novamente.
                    </b-button>

                    <b-button
                      type="is-success"
                      @click="nextStep(1)"
                      style="margin: 1rem;"
                    >
                      Sim!
                    </b-button>
                  </b-message>
                </div>

                <div v-if="notFound">
                  <b-message
                    title="Estudante não encontrado"
                    type="is-danger"
                    :closable="false"
                  >
                    "{{ newLeaderEmail }}" não econtrado. <br />
                    Isso pode ter acontecido por um desses motivos: <br />
                    <br />
                    <span>
                      1. O(A) estudante não está cadastrado(a) na plataforma.
                      Para ser um(a) representante é necessário se cadastrar no
                      Talents: talents.empower.vision/signup
                    </span>
                    <br />

                    <span>
                      2. O e-mail está incorreto. Você pode ter digitado o
                      e-mail errado (com algum espaço, por exemplo) ou esse não
                      é o e-mail que o(a) estudante usou para se cadastrar.
                    </span>
                    <br />

                    <span>
                      3. O(a) estudante se cadastrou, mas não clicou no link de
                      confirmação de cadastro que recebeu no e-mail. Isso é
                      necessário para a conta ser validada.
                    </span>
                    <br />
                    <br />

                    Não é nenhum desses casos? Você pode tentar novamente mais
                    tarde ou entrar em contato conosco via e-mail:

                    <b>suporte@empower.vision</b>
                    <br />
                    <br />

                    <b-button
                      class="button is-primary is-rounded"
                      @click="tryAgain"
                    >
                      Tentar Novamente
                    </b-button>
                  </b-message>
                </div>
              </b-step-item>

              <b-step-item step="4">
                <h1 class="title">Informações Adicionais</h1>

                <span
                  >Complete as demais informações do(a) novo(a)
                  representante:</span
                >
                <div class="column">
                  <b-field label="E-mail" label-position="on-border">
                    <b-input v-model="newLeaderEmail" disabled />
                  </b-field>

                  <b-field label="Nome" label-position="on-border">
                    <b-input v-model="newLeaderName" disabled />
                  </b-field>

                  <b-field label="Posição na OE" label-position="on-border">
                    <b-input
                      v-model="newLeaderPosition"
                      placeholder="Ex.: Presidente"
                    />
                  </b-field>
                  <!-- </div> -->
                  <!-- <div class="column" v-if="recoveredUser.areacode && recoveredUser">
                <b-field label="DDD + Celular" label-position="on-border">
                  <b-select v-model="recoveredUser.areacode">
                    <option value="">DDD</option>
                  </b-select>
                  <b-input expanded v-model="recoveredUser.cellphone">
                </b-field>
              </div> -->
                  <!-- <div class="column"> -->
                  <b-field label="DDD + Celular" label-position="on-border">
                    <b-select v-model="newLeaderAreacode" id="leaderareacode">
                      <option value="">DDD</option>
                    </b-select>
                    <b-input
                      expanded
                      v-model="newLeaderCellphone"
                      :value="newLeaderCellphone"
                      type="tel"
                      placeholder="00000-0000"
                      @input.native="
                        formatCellphoneWithoutAreacode('newLeaderCellphone')
                      "
                    />
                  </b-field>
                </div>

                <span v-if="!validateInformation" style="color: red"
                  >Insira todas as informações (Posição na OE, DDD e número de
                  telefone celular) <br
                /></span>
                <br />

                <b-button
                  class="button is-primary is-rounded"
                  @click="nextStep(1)"
                  style="margin: auto; display: block;"
                  :disabled="!validateInformation"
                >
                  Confirmar
                </b-button>
              </b-step-item>

              <b-step-item step="5">
                <h1 class="title">Salvar</h1>

                <span>Os(As) novos(as) representantes da OE serão:</span> <br />
                <br />

                <b-message>
                  <div v-if="recoveredUser">
                    Nome: {{ recoveredUser.name }} {{ recoveredUser.surname }}
                    <br />
                    Curso: {{ recoveredUser.course }} <br />
                    Posição na OE: {{ newLeaderPosition }} <br />
                    Celular: ({{ newLeaderAreacode }}) {{ newLeaderCellphone }}
                    <hr />
                  </div>

                  <div v-if="!leader1Selected">
                    Nome: {{ organization.leader1.name }}
                    {{ organization.leader1.surname }} <br />
                    Curso: {{ organization.leader1.course }} <br />
                    Posição na OE: {{ organization.leader1.position }} <br />
                    <span
                      v-if="organization.leader1.cellphone"
                      style="color: #4a4a4a"
                    >
                      Celular: ({{ organization.leader1.areacode }})
                      {{ organization.leader1.cellphone }}
                    </span>
                    <hr />
                  </div>

                  <div v-else>
                    Nome: {{ organization.leader2.name }}
                    {{ organization.leader2.surname }} <br />
                    Curso: {{ organization.leader2.course }} <br />
                    Posição na OE: {{ organization.leader2.position }} <br />
                    <span
                      v-if="organization.leader2.cellphone"
                      style="color: #4a4a4a"
                    >
                      Celular: ({{ organization.leader2.areacode }})
                      {{ organization.leader2.cellphone }}
                    </span>
                  </div>
                </b-message>

                <b-button
                  class="button is-primary is-rounded"
                  @click="changeStudent"
                >
                  Salvar Alterações
                </b-button>
              </b-step-item>

              <template #navigation="">
                <b-button
                  outlined
                  type="is-danger"
                  :disabled="previousDisabled"
                  @click.prevent="nextStep(-1)"
                  icon-left="backward"
                  v-if="hideButtons"
                  style="margin: 1rem;"
                  >Voltar</b-button
                >

                <b-button
                  outlined
                  type="is-success"
                  :disabled="nextDisabled"
                  @click.prevent="nextStep(1)"
                  icon-right="forward"
                  v-if="false"
                  >Próximo</b-button
                >
              </template>
            </b-steps>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import tip from "./commom/Tip2";
import LateralMenu from "../lateral-menu/LateralMenu";
import { mapGetters } from "vuex";
import SelectLeader from "./change-leaders/SelectLeader";
import { ddds } from "../../assets/js/ddds";
import { commom } from "../../mixins/commom";
import { mask } from "../../mixins/mask";

export default {
  name: "ChangeLeadersPanel",

  mixins: [commom, mask],

  components: {
    tip,
    LateralMenu,
    SelectLeader
  },

  data() {
    return {
      isLoading: false,
      tip1:
        "Certifique-se de que o(a) novo(a) representante esteja cadastrado(a) na plataforma, e tenha o e-mail que ele(a) usou para se cadastrar em mãos, é necessário para realizar a operação.",
      tip2:
        "Os representantes só podem ser trocados um por vez, então se pretende trocar ambos, comece pelo o que não é você, pois a partir do momento que você deixar de ser representante, não conseguirá mais realizar a operação.",
      tip3:
        "Não esqueça de SALVAR as alterações após confirmar as informações, o site lhe avisará quando tudo estiver finalizado.",
      info: {
        infoBorder: true,
        buttonText: "DICA",
        descriptionText:
          "Mantenha o Perfil da sua OE sempre atualizado e aumente as chances de serem convidados a participar de Parcerias Exclusivas com as Empresas Mentoras."
      },
      leaderSelected: null,
      leader1Selected: false,
      leader2Selected: false,
      activeStep: 0,
      newLeaderEmail: "",
      recoveredUser: null,
      notFound: false,
      newLeaderName: "",
      newLeaderPosition: "",
      newLeaderAreacode: "",
      newLeaderCellphone: ""
    };
  },

  computed: {
    ...mapGetters(["organization", "account"]),

    previousDisabled() {
      return this.activeStep == 0 ? true : false;
    },

    nextDisabled() {
      return this.activeStep == 4 || this.activeStep == 1 ? true : false;
    },

    hideButtons() {
      return this.activeStep == 0 ? false : true;
    },

    validateInformation() {
      return this.newLeaderPosition == "" ||
        this.newLeaderAreacode == "" ||
        this.newLeaderCellphone.length < 9
        ? false
        : true;
    }
  },

  methods: {
    selectLeader(leader) {
      if (leader == "leader1") {
        this.leader1Selected = true;
        this.leader2Selected = false;
        this.confirmSelectedLeader(this.organization.leader1);
      } else {
        this.leader1Selected = false;
        this.leader2Selected = true;
        this.confirmSelectedLeader(this.organization.leader2);
      }
    },

    confirmSelectedLeader(leader) {
      if (leader.email == this.account.email) {
        this.$buefy.dialog.confirm({
          title: "Aviso!",
          message:
            "Você está prestes a perder sua posição de representante d" +
            this.organization.treatmentPronoun +
            " " +
            this.organization.name +
            ". Após realizar essa ação, você não poderá mais realizar solicitações de ações, enviar contrapartidas, editar as informações da OE ou trocar outros representantes. Deseja prosseguir com a ação?",
          cancelText: "Não",
          confirmText: "Sim!",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => {
            this.nextStep(1);
            this.leaderSelected = leader;
          }
        });
      } else {
        this.$buefy.dialog.confirm({
          title: "Aviso!",
          message:
            "Você está prestes a tirar " +
            leader.name +
            " da sua posição de representante d" +
            this.organization.treatmentPronoun +
            " " +
            this.organization.name +
            ". Após realizar essa ação, " +
            leader.name +
            " não poderá mais realizar solicitações de ações, enviar contrapartidas, editar as informações da OE ou trocar outros representantes. Deseja prosseguir com a ação?",
          cancelText: "Não",
          confirmText: "Sim!",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => {
            this.nextStep(1);
            this.leaderSelected = leader;
          }
        });
      }
    },

    nextStep(n) {
      this.activeStep = this.activeStep + n;
    },

    checkStudentEmail() {
      this.isLoading = true;
      this.$store
        .dispatch("checkStudentEmail", {
          email: this.newLeaderEmail
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.recoveredUser = res.data.payload;
            this.newLeaderName =
              res.data.payload.name + " " + res.data.payload.surname;
            this.notFound = false;
          } else {
            if (res.data.message !== "STUDENT_NOT_FOUND") {
              this.alertError(res.data);
            }
            this.recoveredUser = null;
            this.notFound = true;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
          this.recoveredUser = null;
          this.notFound = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    tryAgain() {
      this.recoveredUser = null;
      this.newLeaderName = "";
      this.notFound = false;
    },

    changeStudent() {
      this.isLoading = true;
      let oldLeaderEmail = "";
      if (this.leader1Selected) {
        oldLeaderEmail = this.organization.leader1.email;
      } else {
        oldLeaderEmail = this.organization.leader2.email;
      }
      this.$store
        .dispatch("updateOrganizationLeader", {
          oldLeaderEmail: oldLeaderEmail,
          newLeaderEmail: this.newLeaderEmail,
          newLeaderPosition: this.newLeaderPosition,
          newLeaderAreaCode: this.newLeaderAreacode,
          newLeaderCellphone: this.newLeaderCellphone,
          newLeaderName: this.recoveredUser.name,
          newLeaderSurname: this.recoveredUser.surname,
          newLeaderCourse: this.recoveredUser.course
        })
        .then(res => {
          if (res.data.result === "ok") {
            if (this.account.email === oldLeaderEmail) {
              this.$buefy.dialog.alert({
                title: "Sucesso!",
                message:
                  "O(A) representante foi trocado(a) com sucesso e todas as informações foram salvas! Obrigado por manter as informações da OE atualizadas, agora você será redirecionado(a) para a página inicial.",
                type: "is-success",
                hasIcon: true,
                icon: "check",
                confirmText: "OK!",
                onConfirm: () => this.modifyUserSession()
              });
            } else {
              this.$buefy.dialog.alert({
                title: "Sucesso!",
                message:
                  "O(A) representante foi trocado(a) com sucesso e todas as informações foram salvas! Obrigado por manter as informações da OE atualizadas, agora você será redirecionado(a) para a página inicial.",
                type: "is-success",
                hasIcon: true,
                icon: "check",
                confirmText: "OK!",
                onConfirm: () => this.$router.push("opportunities")
              });
            }
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    modifyUserSession() {
      this.$store.dispatch("userNotOrganizationLeaderAnymore");
      this.$router.push("opportunities");
    }
  },

  mounted() {
    let dddsOptions = "";
    const dddslen = ddds.length;
    for (let i = 0; i < dddslen; i++)
      dddsOptions += `<option value="${ddds[i]}">${ddds[i]}</option>`;
    document.getElementById("leaderareacode").innerHTML += dddsOptions;
  }
};
</script>

<style scoped>
.CLSection {
  background-color: #e9e9e9;
}
.CL {
  padding-top: 5rem;
  padding-bottom: 1rem;
  max-width: 75rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.CLBody {
  display: grid;
  grid-template-columns: auto auto;
  gap: 0.5rem;
}
.LateralMenu {
  background-color: #e9e9e9;
}
.CLContent {
  background-color: white;
  margin-top: 0.7rem;
  border-radius: 0.5rem;
}
.stepContent {
  padding: 2rem;
}
.representativeHeader {
  background: rgb(2, 209, 168);
  background: linear-gradient(
    90deg,
    rgba(2, 209, 168, 1) 0%,
    rgba(95, 255, 223, 1) 100%,
    rgba(60, 247, 210, 1) 100%
  );
  border: transparent;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
}
.representativeTitle {
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 2rem;
  margin-top: 0.5rem;
}
.leaders {
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;
  margin: 0.5rem;
}
.leaderSelected {
  background-color: rgb(2, 209, 168);
  border: solid 1rem rgb(2, 209, 168);
  border-radius: 0.5rem;
  transform: scale(0.97);
}
@media (max-width: 750px) {
  .leaders {
    grid-template-columns: auto;
  }
  .stepContent {
    padding: 0rem;
  }
}
</style>
